import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from "../components/PopUP";
import api from "../Api";

export default function AdminDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [adminDetail, setAdminDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [popupMessage, setPopupMessage] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const fetchAdminDetail = async () => {
      try {
        const response = await api.get(`/user-service/user/admin/${id}`);
        console.log("Admin Detail:", response.data);
        setAdminDetail(response.data.data);
        if (response.data.data.permissions) {
          setSelectedPermissions(response.data.data.permissions.map(p => p.id));
        }
      } catch (error) {
        console.error("API Error:", error.message);
        setPopupMessage("Failed to load admin details");
      } finally {
        setLoading(false);
      }
    };
    fetchAdminDetail();
  }, [id]);

  const handlePermissionChange = (permissionId) => {
    setSelectedPermissions((prev) =>
      prev.includes(permissionId)
        ? prev.filter((id) => id !== permissionId)
        : [...prev, permissionId]
    );
  };

  const handleUpdatePermissions = async () => {
    setIsUpdating(true);
    try {
      const response = await api.put(`/user-service/user/admin/${id}/permissions`, {
        permissions: selectedPermissions,
      });
      console.log("Permissions updated:", response.data);
      setPopupMessage("Permissions updated successfully");
      // Refresh admin detail
      const updatedResponse = await api.get(`/user-service/user/admin/${id}`);
      setAdminDetail(updatedResponse.data.data);
    } catch (error) {
      console.error("API Error:", error.message);
      setPopupMessage("Failed to update permissions");
      // Reset selected permissions to original state
      setSelectedPermissions(adminDetail.permissions.map(p => p.id));
    } finally {
      setIsUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="user-management-page">
        <Sidebar />
        <div className="main-wrapper">
          <Header />
          <div className="content-wrapper">
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!adminDetail) {
    return (
      <div className="user-management-page">
        <Sidebar />
        <div className="main-wrapper">
          <Header />
          <div className="content-wrapper">
            <p>No admin details found</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <nav className="breadcrumb_nav">
                          <ul className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                              <Link to="/">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/sub-admin">SubAdmin Management</Link>
                            </li>
                            <li className="breadcrumb-item text-capitalize">Admin Detail</li>
                          </ul>
                        </nav>
                        <h1>Admin Detail</h1>
                      </div>
                      <div className="d-flex flex-end">
                        <button
                          className="secondary_btn"
                          onClick={() => navigate(-1)}
                        >
                          ← Back
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="tab_blk">
                    <div className="tab-content" id="nav-tabContent">
                        {/* Personal Information */}
                        <div className="common-outer-card">
                          <div className="common_sub_heading_wrapper">
                            <h2>Personal Information</h2>
                          </div>
                          <div className="common_content_blk">
                            <div className="box_card common-card">
                              <div className="box_detail_blk">
                                <div className="box_info_list">
                                  <div className="box_info_context">
                                    <p className="box_info_title">First Name</p>
                                    <p className="box_info_data text-capitalize">
                                      {adminDetail.first_name}
                                    </p>
                                  </div>
                                  <div className="box_info_context">
                                    <p className="box_info_title">Last Name</p>
                                    <p className="box_info_data text-capitalize">
                                      {adminDetail.last_name}
                                    </p>
                                  </div>
                                  <div className="box_info_context">
                                    <p className="box_info_title">Email Address</p>
                                    <p className="box_info_data">{adminDetail.email}</p>
                                  </div>
                                  <div className="box_info_context">
                                    <p className="box_info_title">User Type</p>
                                    <p className="box_info_data text-capitalize">
                                      {adminDetail.sub_admin_role ? adminDetail.sub_admin_role.replaceAll("_", " ") : "Admin"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Account Information */}
                        <div className="common-outer-card mt-4">
                          <div className="common_sub_heading_wrapper">
                            <h2>Account Information</h2>
                          </div>
                          <div className="common_content_blk">
                            <div className="box_card common-card">
                              <div className="box_detail_blk">
                                <div className="box_info_list">
                                  <div className="box_info_context">
                                    <p className="box_info_title">Auth Type</p>
                                    <p className="box_info_data text-capitalize">
                                      {adminDetail.auth_type?.replace("_", " ")}
                                    </p>
                                  </div>
                                  <div className="box_info_context">
                                    <p className="box_info_title">Status</p>
                                    <p className="box_info_data">
                                      {adminDetail.is_active ? (
                                        <span className="badge bg-success">Active</span>
                                      ) : (
                                        <span className="badge bg-danger">Inactive</span>
                                      )}
                                    </p>
                                  </div>
                                  <div className="box_info_context">
                                    <p className="box_info_title">Last login at</p>
                                    <p className="box_info_data">
                                      <span className="badge bg-info">
                                        {adminDetail.last_login ? adminDetail.last_login : "Never logged in"}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="box_info_context">
                                    <p className="box_info_title">Created At</p>
                                    <p className="box_info_data">{adminDetail.created_at}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Permissions Section */}
                        {/*<div className="common-outer-card mt-4">*/}
                        {/*  <div className="common_sub_heading_wrapper">*/}
                        {/*    <h2>Assigned Permissions</h2>*/}
                        {/*  </div>*/}
                        {/*  {adminDetail.permissions && adminDetail.permissions.length > 0 ? (*/}
                        {/*    <>*/}
                        {/*      <div className="common_content_blk">*/}
                        {/*        {adminDetail.permissions.map((permission) => (*/}
                        {/*          <div key={permission.id} className="form-check mb-3">*/}
                        {/*            <input*/}
                        {/*              className="form-check-input"*/}
                        {/*              type="checkbox"*/}
                        {/*              id={`permission-${permission.id}`}*/}
                        {/*              checked={selectedPermissions.includes(permission.id)}*/}
                        {/*              onChange={() => handlePermissionChange(permission.id)}*/}
                        {/*            />*/}
                        {/*            <label*/}
                        {/*              className="form-check-label"*/}
                        {/*              htmlFor={`permission-${permission.id}`}*/}
                        {/*            >*/}
                        {/*              {permission.name}*/}
                        {/*            </label>*/}
                        {/*          </div>*/}
                        {/*        ))}*/}
                        {/*      </div>*/}
                        {/*      <div className="common_content_blk">*/}
                        {/*        <button*/}
                        {/*          className="primary-btn rounded-pill"*/}
                        {/*          onClick={handleUpdatePermissions}*/}
                        {/*          disabled={isUpdating}*/}
                        {/*        >*/}
                        {/*          {isUpdating ? "Updating..." : "Update Permissions"}*/}
                        {/*        </button>*/}
                        {/*      </div>*/}
                        {/*    </>*/}
                        {/*  ) : (*/}
                        {/*    <div className="common_content_blk">*/}
                        {/*      <div className="alert alert-info">*/}
                        {/*        No permissions assigned to this admin.*/}
                        {/*      </div>*/}
                        {/*    </div>*/}
                        {/*  )}*/}
                        {/*</div>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
        </div>
      </div>
    </>
  );
}
